<mat-form-field *ngIf="isVisible" [appearance]="appearance" [formGroup]="formGroup" class="app-datepicker">
  <mat-label>{{label | translate}}</mat-label>

  <input matInput
         [id]="'nc-date-picker-' + id"
         (keypress)="dateFormatFilter($event)"
         [matDatepicker]="picker"
         autocomplete="off"
         [readonly]="isReadonly"
         [formControl]="control"
         maxlength="10">
  <mat-datepicker-toggle [disabled]="isReadonly" matSuffix [for]="picker" tabIndex="-1"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  <mat-error *ngIf="isControlInvalid()">
    <ng-container *ngIf="getErrorMessage() as errorLabel">
      {{errorLabel.label | translate:errorLabel.parameters }}
    </ng-container>
  </mat-error>
</mat-form-field>
